// extracted by mini-css-extract-plugin
export default {"fullWidth":"Mn-z","image":"Nn-z","lazyLoadPicture":"On-z","lazyLoadSpinner":"Pn-z","lazyLoadSpin":"Qn-z","lazyLoadImage":"Rn-z","hasStyledAspectRatio":"Sn-z"};